/**
 * 课程标准 api
 * 课程标准api
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The PaperCreateForm model module.
   * @module course_standard/model/PaperCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>PaperCreateForm</code>.
   * @alias module:course_standard/model/PaperCreateForm
   * @class
   * @param courseStandardId {Integer} 课程 标准id
   * @param type {Integer} 0:固定选题组卷，1:随机抽题组卷，暂时只用1随机抽题组卷
   * @param name {String} 试卷名称
   */
  var exports = function(courseStandardId, type, name) {
    var _this = this;

    _this['courseStandardId'] = courseStandardId;
    _this['type'] = type;
    _this['name'] = name;
  };

  /**
   * Constructs a <code>PaperCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:course_standard/model/PaperCreateForm} obj Optional instance to populate.
   * @return {module:course_standard/model/PaperCreateForm} The populated <code>PaperCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'courseStandardId')) {
        obj['courseStandardId'] = ApiClient.convertToType(data['courseStandardId'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'type')) {
        obj['type'] = ApiClient.convertToType(data['type'], 'Integer');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
    }
    return obj;
  }

  /**
   * 课程 标准id
   * @member {Integer} courseStandardId
   */
  exports.prototype['courseStandardId'] = undefined;
  /**
   * 0:固定选题组卷，1:随机抽题组卷，暂时只用1随机抽题组卷
   * @member {Integer} type
   */
  exports.prototype['type'] = undefined;
  /**
   * 试卷名称
   * @member {String} name
   */
  exports.prototype['name'] = undefined;



  export default exports;
;


